<template>
  <div class="my_checkbox_layer m-lr-11">
    <p :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" :style="{
        width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth
      }"></span>
      <el-checkbox-group v-model="check_list" @change="change" style="margin-left: 8px;">
        <el-checkbox
          v-for="(item,index) in option"
          :key="index"
          :disabled="item.disabled !== undefined ? (item.disabled == 'true' ? true : false) : false"
          :label="item.value">{{$t(item.label)}}</el-checkbox>
      </el-checkbox-group>
    </p>
  </div>
</template>

<script>
import i18n from '../../language/index'

  export default {
    name:'my_checkbox_index',
    props:{
      titleWidth: {
        type:String,
        default: '40'
      },
      title: { // 组件的标题
        type:String,
        default: ''
      },
      type: { // 组件的类型  one_level 一级组件 two_level 二级组件
        type:String,
        default: 'two_level'
      },
      option:{ // 数组
        type:Array,
        default:function () {
          return this.$store.state.options.borderPosition
        }
      },
      checkList:{ // 数组
        type:Array,
        default:function () {
          return []
        }
      },
    },
    data(){
      return {
        Result:this.value,
        check_list: JSON.parse(JSON.stringify(this.checkList))
      }
    },
    mounted() {
    },
    watch:{
      check_list(val){
        this.$emit('update:checkList',val);//双向数据绑定
      },
      'checkList'(val){
        this.check_list = val
      }
    },
    computed:{
    },
    methods:{
      change(val){
        this.$emit('update:checkList',val);
      }
    }
  }
</script>

<style scoped lang="scss">
  .el-checkbox-group {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/my_checkbox/index.vue